<template>
  <v-list-item
    link
    :input-value="isActive"
    @click="handleClick"
    class="my-0 py-0 nav_item"
    :class="{
      'pl-7': minimizedDrawer,
      'pl-3 pr-1 py-1': !minimizedDrawer && !isMobile,
      'py-1': !minimizedDrawer && isMobile,
      'nav_item--active-custom': isActive && !minimizedDrawer,
      'nav_item--active-custom_minimized': isActive && minimizedDrawer,
      'nav_item--hover-custom': !isActive,
    }"
    color="plusPrimary"
    :data-v-step="dataVStep"
  >
    <template v-slot:default="{ active }">
      <v-list-item-action class="mx-0 px-0 mr-2">
        <div v-if="active" class="nav-active-indicator"></div>

        <v-badge
          v-if="badge && badge > 0"
          :content="badge"
          color="error"
          overlap
        >
          <v-icon size="20" :color="iconColor">{{ icon }}</v-icon>
        </v-badge>
        <v-icon v-else size="20" :color="iconColor">{{ icon }}</v-icon>
      </v-list-item-action>

      <div class="py-0 my-0">
        <div
          :class="[
            'font-roboto body-2 font-weight-regular py-0 my-0 hover-text',
            textClass,
          ]"
        >
          {{ title }}
        </div>
      </div>
    </template>
  </v-list-item>
</template>

<style scoped>
.nav_item::before,
.nav_item::after {
  opacity: 0 !important;
  border-radius: 4px;
}

.nav_item.v-list-item--active::before {
  opacity: 0 !important;
}

.nav-active-indicator {
  position: absolute;
  left: 4px;
  top: 4px;
  width: 4px;
  height: calc(100% - 8px);
  background-color: var(--v-plusIndigoDarken2-base);
  border-radius: 2px;
  z-index: 10;
}

@media (max-width: 960px) {
  .nav-active-indicator {
    left: 0;
    top: 0;
    height: 100%;
    border-radius: 0 2px 2px 0;
  }

  .nav_item--active-custom {
    border-radius: 0 !important;
    background: linear-gradient(90deg, #e8eaf6 0%, transparent 100%) !important;
  }

  .nav_item--hover-custom:hover {
    background-color: transparent !important;
  }
}

.nav_item--hover-custom:hover {
  background-color: #e8eaf6 !important;
  font-weight: 600 !important;
}

.nav_item--active-custom {
  background: linear-gradient(90deg, #e8eaf6 0%, #fafafa 90.87%) !important;
  border-radius: 4px !important;
}

.nav_item--active-custom_minimized {
  background: linear-gradient(90deg, #e8eaf6 0%, #fafafa 90.87%) !important;
  border-radius: 4px !important;
  padding-left: 16px !important;
}

.theme--dark .nav_item--hover-custom:hover {
  background-color: #424242 !important;
}

.theme--dark .nav_item--active-custom,
.theme--dark .nav_item--active-custom_minimized {
  background: linear-gradient(
    90deg,
    #3949ab 20%,
    rgba(0, 0, 0, 0.26) 100%
  ) !important;
}

@media (max-width: 960px) {
  .theme--dark .nav_item--active-custom {
    background: linear-gradient(90deg, #3949ab 0%, transparent 100%) !important;
  }

  .theme--dark .nav_item--hover-custom:hover {
    background-color: transparent !important;
  }
}

.theme--dark .nav-active-indicator {
  background-color: #c5cae9;
}

.nav_item--active-custom::before,
.nav_item--active-custom_minimized::before {
  opacity: 0 !important;
}

.nav_item .v-ripple__container {
  opacity: 0 !important;
}

.nav_item .v-list-item__title {
  z-index: 1000;
}

.active-text {
  color: var(--v-plusNavActiveText-base) !important;
  font-weight: 600 !important;
}

.hover-text:hover,
.nav_item:hover .hover-text {
  font-weight: 600 !important;
}
</style>

<script>
export default {
  name: 'NavItem',
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
      default: null,
    },
    routeNames: {
      type: Array,
      default: () => [],
    },
    badge: {
      type: Number,
      default: null,
    },
    minimizedDrawer: {
      type: Boolean,
      default: false,
    },
    dataVStep: {
      type: String,
      default: null,
    },
  },
  computed: {
    isActive() {
      if (this.routeNames && this.routeNames.length > 0) {
        return this.routeNames.includes(this.$route.name);
      }
      return this.$route.name === this.routeName;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    iconColor() {
      return this.isActive ? 'plusNavActiveText' : 'plusTextSecondary';
    },
    textClass() {
      return this.isActive ? 'active-text' : 'plusTextSecondary--text';
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
      this.$emit('navigate', this.routeName);
    },
  },
};
</script>
